import styled from 'styled-components';

const desktopNamespace = 'filter-bar-desktop';

export const StyledFilterBarDesktopContainer = styled.div<{ fullWidth?: boolean }>`
  display: flex;
  margin: 10px 10px 30px 10px;
  font-family: var(--ion-font-family);
  font-style: normal;
  font-weight: 600;
  font-size: 21px;
  line-height: 28px;
  flex-wrap: wrap;
  row-gap: 12px;

  .${desktopNamespace}__label {
    display: flex;
    align-items: center;
    margin-right: 10px;
    font-weight: 400;
  }

  .${desktopNamespace}__container-item {
    display: flex;
    flex-wrap: wrap;
    row-gap: 10px;
    column-gap: 10px;
    flex-grow: 1;
  }

  .${desktopNamespace}__item {
    align-self: center;
    height: fit-content;
    display: flex;
    align-items: center;
    background: #ffffff;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    border-radius: 8px;
    padding-left: 20px;
    border: 1px solid var(--allie-color-light-40);
    max-width: ${({ fullWidth }) => (fullWidth ? 'none' : '232px')};
    width: 100%;
    justify-content: space-between;
    box-sizing: border-box;

    &__select {
      border: none;
      font-weight: 400;
      font-size: 12px;

      &::part(icon) {
        color: var(--allie-color-neutral-60);
        opacity: 1;
      }
    }

    &__searchable {
      display: contents;

      & > ion-item {
        border: none;
        color: var(--allie-color-neutral-90);
        height: 39px;

        ion-icon {
          fill: var(--allie-color-neutral-60);
        }
      }
    }
  }

  .${desktopNamespace}__label {
    margin-right: 10px;
  }
`;

const mobileNamespace = 'filter-bar-mobile';

export const StyledFilterBarMobileContainer = styled.div`
  display: flex;
  margin: 0;
  font-family: var(--ion-font-family);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 28px;
  overflow: scroll;
  padding: 10px 10px 0;

  // Hide scrollbar for most browsers
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;

  .${mobileNamespace}__label {
    display: flex;
    align-items: center;
    margin-right: 10px;
  }

  .${mobileNamespace}__container-item {
    display: flex;
    flex-wrap: no-wrap;
    row-gap: 10px;
    column-gap: 10px;
  }

  .${mobileNamespace}__item {
    display: flex;
    align-items: center;
    margin-right: 10px;
    background: inherit;
    padding: 0;

    &__select {
      font-weight: 400;
      font-size: 12px;

      &::part(icon) {
        color: var(--allie-color-neutral-60);
        opacity: 1;
      }
    }
  }
`;
